import axios from 'plugins/axios'

export const state = {
  list: []
}

export const getters = {
  categories (state) {
    return state.list
  },
  countCategories (state) {
    return state.list.length
  },
  getCategoryById: (state, getters) => (id) => {
    if (state.list.length === 0) return null
    return state.list.find(category => category.id === id)
  }
}

export const mutations = {
  add (state, category) {
    let oldCategory = state.list.find(c => c.id === category.id)

    if (oldCategory) {
      return state.list.splice(state.list.indexOf(oldCategory), 1, category)
    }

    return state.list.push(category)
  }
}

export const actions = {
  async request ({state, commit}, forceRequest) {
    if (!forceRequest && state.list.length) return
    let {data} = await axios.get('/categories')
    data.data.forEach(category => commit('add', category))
  }
}



// WEBPACK FOOTER //
// ./client/store/categories.js